import Axios from "axios";
import {initPersonForm} from "./form";
import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";

function initPeopleEdit() {
	const personForm = initPersonForm(document.querySelector('.person-form'));

	document.querySelector('.update-person-button').onclick =
		() => editPerson(false);
	document.querySelector('.update-and-checkin-person-button').onclick =
		() => editPerson(true);

	/**
	 * Methods
	 */

	function editPerson(checkin = false) {
		const personData = personForm.inputs();

		if (new URLSearchParams(window.location.search).get('fromCheckin')) {
			personData._fromCheckin = true;
		}

		if (checkin) {
			personData._checkin = true;
			personData.households = 1;
		}

		personForm.clearFeedbacks();

		loading();

		Axios.post(personForm.postUrl(), personData)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {initPeopleEdit}
